import graphqlClient from '~/graphql/graphqlClient';

const mutation = `
mutation PlaceItemInGlobalInventory(
  $playerId: String!
  $itemId: String!
  $from: ItemLocationInput!
  $to: ItemLocationInput!
) {
  placeItemInGlobalInventory(
    playerId: $playerId
    itemId: $itemId
    from: $from
    to: $to
  ) {
    inventory
    heroRoster
  }
}
`;

export type ItemLocationInput = {
  location: string;
  heroHandle?: string;
  bagSlotIndex?: number;
  bagIndex?: number;
  bagItemIndex?: number;
};

export type PlaceItemInGlobalInventoryArgs = {
  playerId: string;
  itemId: string;
  from: ItemLocationInput;
  to: ItemLocationInput;
};

export type ItemMoveResult = {
  inventory: any;
  heroRoster?: any;
};

export default async function mutationPlaceItemInGlobalInventory(
  args: PlaceItemInGlobalInventoryArgs
): Promise<ItemMoveResult> {
  return await graphqlClient.request<ItemMoveResult>(
    'placeItemInGlobalInventory',
    mutation,
    args
  );
}
